const type = "website";

module.exports = type;
